const Bybit = ({ ...props }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
    <g clipPath='url(#clip0_1110_94)'>
      <path
        d='M0 5.1C0 2.28335 2.28335 0 5.1 0H18.9C21.7166 0 24 2.28335 24 5.1V18.9C24 21.7166 21.7166 24 18.9 24H5.1C2.28335 24 0 21.7166 0 18.9V5.1Z'
        fill='#404347'
      />
      <path
        d='M2.06625 7.31091C1.85052 6.56691 2.31207 5.79629 3.06981 5.63536L15.7115 2.95017C16.3116 2.82272 16.9212 3.12117 17.1886 3.67333L22.8667 15.3997L6.86664 23.8664L2.06625 7.31091Z'
        fill='url(#paint0_linear_1110_94)'
      />
      <path
        d='M2.2316 8.22593C2.00471 7.44102 2.53073 6.63852 3.34099 6.53341L20.0963 4.36038C20.7925 4.2701 21.4394 4.73502 21.5758 5.42363L24.0001 17.6665L6.73345 23.7999L2.2316 8.22593Z'
        fill='white'
      />
      <path
        d='M0 9.33333C0 7.86058 1.19391 6.66669 2.66667 6.66669H18.6667C21.6122 6.66669 24 9.0545 24 12V18.6667C24 21.6122 21.6122 24 18.6667 24H5.33335C2.38781 24 0 21.6122 0 18.6667V9.33333Z'
        fill='black'
      />
      <path d='M15.8782 16.6898V11.6933H16.8528V16.6898H15.8782Z' fill='#F7A600' />
      <path
        d='M4.75626 18.181H2.66675V13.1846H4.67221C5.64683 13.1846 6.21478 13.732 6.21478 14.588C6.21478 15.1422 5.85014 15.5003 5.59795 15.6197C5.89953 15.7601 6.2852 16.0756 6.2852 16.7423C6.2852 17.6757 5.64683 18.181 4.75626 18.181ZM4.59497 14.0548H3.64138V15.2059H4.59497C5.00845 15.2059 5.24016 14.9745 5.24016 14.6306C5.24016 14.2862 5.009 14.0548 4.59497 14.0548ZM4.65803 16.083H3.64138V17.3108H4.65803C5.09987 17.3108 5.31003 17.03 5.31003 16.6934C5.31058 16.3564 5.09987 16.083 4.65803 16.083Z'
        fill='white'
      />
      <path
        d='M8.97067 16.1319V18.181H8.00287V16.1319L6.50232 13.1846H7.56102L8.49358 15.1985L9.41199 13.1846H10.4707L8.97067 16.1319Z'
        fill='white'
      />
      <path
        d='M13.2446 18.181H11.155V13.1846H13.1605C14.1351 13.1846 14.7031 13.732 14.7031 14.588C14.7031 15.1422 14.3384 15.5003 14.0862 15.6197C14.3878 15.7601 14.7735 16.0756 14.7735 16.7423C14.7729 17.6757 14.1346 18.181 13.2446 18.181ZM13.0833 14.0548H12.1296V15.2059H13.0833C13.4967 15.2059 13.7285 14.9745 13.7285 14.6306C13.7279 14.2862 13.4967 14.0548 13.0833 14.0548ZM13.1463 16.083H12.1296V17.3108H13.1463C13.5882 17.3108 13.7983 17.03 13.7983 16.6934C13.7983 16.3564 13.5876 16.083 13.1463 16.083Z'
        fill='white'
      />
      <path d='M20.0288 14.0548V18.181H19.0542V14.0548H17.7501V13.1846H21.3333V14.0548H20.0288Z' fill='white' />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_1110_94'
        x1='1.99995'
        y1='6.98018'
        x2='23.0831'
        y2='5.92407'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFD748' />
        <stop offset='1' stopColor='#F7A600' />
      </linearGradient>
      <clipPath id='clip0_1110_94'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
);

export default Bybit;
